import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./Login.scss";

// prop types
import userPropTypes from "../../propTypes/userPropTypes";

// actions
import * as loginActions from "../../actions/loginActions";
import * as oAuthActions from "../../actions/oAuthActions";
import * as verifyActions from "../../actions/verifyActions";

//components
import GoogleButton from "../../coraWebComponents/buttons/GoogleButton";
import Login from "../../coraWebComponents/views/login/FullscreenLogin";
import CookieInfo from "../CookieInfo";
import { afterLoginHandle, buildUrl } from "../../coraWebComponents/utils/helper";
import withRouter from "../../coraWebComponents/utils/withRouter";
import { showMsg } from '../../coraWebComponents/utils/logger';
import { useDidMount } from "../../coraWebComponents/utils/hooks";

// routes
import Routes from "../../constants/Routes";

const googleRedirectURI = `${window.config.redirectURI}?provider=1`;

const LoginWrapper = (props) => {
  const signInOAuthHandle = async (loginProps, code, provider) => {
    await props.signInOAuth(code, googleRedirectURI, provider);

    const { user } = props;
    if (user !== null) afterLoginHandle(loginProps, user.Uzivatel.N_UZ);
  };

  const verifyGUID = async (guid) => {
    await props.verifyGUID(guid);
  };

  const location = useLocation();
  const navigate = useNavigate();

  useDidMount(async () => {
    if (location && location.state) {
      navigate(location.pathname, { replace: true });
    }
  });

  const { user, isLoading, signIn } = props;

  return (
    <Login
      user={user}
      isLoading={isLoading}
      signIn={signIn}
      rememberDisabled={false}
      logoUrl={buildUrl('assets/cg_logo_login.svg')}
      backgroundUrl={buildUrl('assets/background_login.svg')}
      appFullName={"Zákaznícky informačný portál"}
      userNameLabel="Prihlasovacie meno / Email"
      passwordLabel="Heslo"
      oAuthLogin={signInOAuthHandle}
      verifyGUID={verifyGUID}
      afterLoginlocation={{ from: { pathname: Routes.HOME } }}
      showMsg={props.showMsg}
      showForgotPassword={true}
      routeForgotPassword={Routes.FORGOT_PASSWORD}
      loginFooter={<CookieInfo />}
    >
      <div className="k-form-field">
        <div className="line">
          <span className="service-label">alebo</span>
        </div>
        <div className="row m-0">
          <GoogleButton
            redirectURI={googleRedirectURI}
            state="logging"
            primary={false}
          />
        </div>
      </div>

      <div className="k-form-field">
        <div className="footerContainerLogin">Ste tu nový?&nbsp;&nbsp;
          <a className="registration" href={`#${Routes.REGISTRACIA}`}>
            Registrovať sa
          </a>
        </div>
      </div>
    </Login>
  );
}


const mapStateToProps = (state) => ({
  isLoading: state.user.isLoading || state.oAuthUser.isLoading,
  user: state.user.data,
});

const mapDispatchToProps = (dispatch) => ({
  signInOAuth: (code, redirect_uri, provider) => dispatch(oAuthActions.loginOAuth(code, redirect_uri, provider)),
  signIn: (username, password) => dispatch(loginActions.login(username, password)),
  verifyGUID: (guid) => dispatch(verifyActions.GUID(guid)),
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
});

LoginWrapper.propTypes = {
  isLoading: PropTypes.bool,
  signInOAuth: PropTypes.func,
  signIn: PropTypes.func,
  user: userPropTypes.user,
  verifyGUID: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginWrapper)
);
